import React from 'react';
import SVG from 'react-inlinesvg';
import { useIntl } from 'react-intl';
import { NavLink } from 'react-router-dom';
import cn from 'classnames';

import profileIcon from 'assets/images/profile.svg';
import routes from 'routesPaths';

import styles from '../../Menu.module.scss';

function ProfileIcon() {
  const intl = useIntl();
  const label = intl.formatMessage({ id: 'Menu.userProfileText', defaultMessage: 'UserProfile' })
  return (
    <NavLink
      role='link'
      aria-label={label}
      className={({ isActive }) => (isActive ? cn(styles.profileActive, styles.userProfile) : styles.userProfile)}
      to={routes.settings.path}
    >
      <SVG description={label} src={profileIcon} />
      {label}
    </NavLink>
  );
}

export default ProfileIcon;
